import type * as SchemaTypes from '../types';

import type { AuthorData_CorporateCustomer_Fragment, AuthorData_ExternalBank_Fragment, AuthorData_Guarantor_Fragment, AuthorData_LocalCustomer_Fragment, AuthorData_Salesforce_Fragment, AuthorData_SystemBank_Fragment, AuthorData_User_Fragment } from './AuthorData';
import { gql } from '@apollo/client';
import { AuthorDataFragmentDoc } from './AuthorData';
export type SimpleVersioningDataFragment = (
  { __typename: 'SimpleVersioning' }
  & Pick<SchemaTypes.SimpleVersioning, 'createdAt' | 'updatedAt'>
  & { createdBy?: SchemaTypes.Maybe<(
    { __typename: 'CorporateCustomer' }
    & AuthorData_CorporateCustomer_Fragment
  ) | (
    { __typename: 'ExternalBank' }
    & AuthorData_ExternalBank_Fragment
  ) | (
    { __typename: 'Guarantor' }
    & AuthorData_Guarantor_Fragment
  ) | (
    { __typename: 'LocalCustomer' }
    & AuthorData_LocalCustomer_Fragment
  ) | (
    { __typename: 'Salesforce' }
    & AuthorData_Salesforce_Fragment
  ) | (
    { __typename: 'SystemBank' }
    & AuthorData_SystemBank_Fragment
  ) | (
    { __typename: 'User' }
    & AuthorData_User_Fragment
  )>, updatedBy?: SchemaTypes.Maybe<(
    { __typename: 'CorporateCustomer' }
    & AuthorData_CorporateCustomer_Fragment
  ) | (
    { __typename: 'ExternalBank' }
    & AuthorData_ExternalBank_Fragment
  ) | (
    { __typename: 'Guarantor' }
    & AuthorData_Guarantor_Fragment
  ) | (
    { __typename: 'LocalCustomer' }
    & AuthorData_LocalCustomer_Fragment
  ) | (
    { __typename: 'Salesforce' }
    & AuthorData_Salesforce_Fragment
  ) | (
    { __typename: 'SystemBank' }
    & AuthorData_SystemBank_Fragment
  ) | (
    { __typename: 'User' }
    & AuthorData_User_Fragment
  )> }
);

export const SimpleVersioningDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SimpleVersioningData on SimpleVersioning {
  createdBy {
    ...AuthorData
  }
  createdAt
  updatedBy {
    ...AuthorData
  }
  updatedAt
}
    `;